// import Calendar from "@/utils/calendar";

const taglist = [
  { value: 1, label: "转正品" },
  { value: 2, label: "退货" },
  { value: 3, label: "新采购单入库" },
  { value: 10, label: "转公司库存" },
  { value: 11, label: "转用户库存" },
];
const warehouselist = ["待处理", "已处理"];
const servicelist =['未处理','已处理','处理中']

export const columns = [
  {
    title: "#",
    dataIndex: "id",
    key: "id",
    width: 40,
    customRender: (text, record, index) => {
      return index + 1;
    },
  },
  {
    title: "异常批次编号",
    dataIndex: "pkgCode",
    key: "pkgCode",
  },
  {
    title: "异常编码",
    dataIndex: "exceptionRelation",
    key: "exceptionRelation",
  },
  {
    title: "商品名称",
    dataIndex: "productName",
    key: "productName",
  },
  {
    title: "处理结果",
    dataIndex: "tag",
    key: "tag",
    scopedSlots: {
      customRender: "tag",
    },
    // customRender: (text, record) => {
    //   return taglist.map(item =>{
    //     if(item.value == text){
    //       return item.label
    //     }
    //   })
    // },
  },
  {
    title: "异常件数",
    dataIndex: "amount",
    key: "amount",
  },
  {
    title: "异常类型",
    dataIndex: "exceptionNames",
    key: "exceptionNames",
  },
  {
    title: "创建时间",
    dataIndex: "createTime",
    key: "createTime",
  },
  {
    title: "人员处理",
    dataIndex: "createrName",
    key: "createrName",
  },
  {
    title: "业务处理状态",
    dataIndex: "serviceStatus",
    key: "serviceStatus",
    customRender: (text, record) => {
      return servicelist[text];
    },
  },
  {
    title: "仓库处理状态",
    dataIndex: "wareStatus",
    key: "wareStatus",
    customRender: (text, record) => {
      return warehouselist[text];
    },
  },
  {
    title: "异常来源",
    dataIndex: "exceptionSource",
    key: "exceptionSource",
    width: 100,
    customRender: (text,record) => {
        return {1:'简单检品',2:'详细检品'}[text]||'-'
    },
  },
  {
    title: "提交人",
    dataIndex: "createrName",
    key: "createrName",
    customRender: (text,record) => {
        return text||'-'
    },
  },
];

export const dataSource = [
  {
    warehouse: "1",
    regionName: "1",
    regionContact: "1",
    contactPhone: "1",
    address: "1",
    total: "1",
    result: "1",
    num: "1",
    type: "1",
  },
];
